/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/domainsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Domains. */
var Domains = /** @class */ (function () {
    /**
     * Create a Domains.
     * @param {GraphRbacManagementClientContext} client Reference to the service client.
     */
    function Domains(client) {
        this.client = client;
    }
    Domains.prototype.list = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, listOperationSpec, callback);
    };
    Domains.prototype.get = function (domainName, options, callback) {
        return this.client.sendOperationRequest({
            domainName: domainName,
            options: options
        }, getOperationSpec, callback);
    };
    return Domains;
}());
export { Domains };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var listOperationSpec = {
    httpMethod: "GET",
    path: "{tenantID}/domains",
    urlParameters: [
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.filter,
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.DomainListResult
        },
        default: {
            bodyMapper: Mappers.CloudError
        }
    },
    serializer: serializer
};
var getOperationSpec = {
    httpMethod: "GET",
    path: "{tenantID}/domains/{domainName}",
    urlParameters: [
        Parameters.domainName,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.Domain
        },
        default: {
            bodyMapper: Mappers.CloudError
        }
    },
    serializer: serializer
};
//# sourceMappingURL=domains.js.map